<template>
  <div class="subscriptionMb botPage">
    <mbHeader :title="$t('email_subscription')" :left="true" :lang="true"></mbHeader>
<!--    <div class="subscription-title">{{ $t('select_email_preferences') }}:</div>-->
<!--    <el-radio-group class="radio-container" v-model="subValue" @change="subChange">-->
<!--      <el-radio class="radio-single" :label="true">-->
<!--        <div class="radio-big">{{ $t('stay_up_todate') }}</div>-->
<!--        <div class="radio-small">{{ $t('subscribe_newsletter') }}</div>-->
<!--      </el-radio>-->
<!--      <el-radio class="radio-single" :label="false">-->
<!--        <div class="radio-big">{{ $t('unsubscribe_emails') }}</div>-->
<!--        <div class="radio-small">{{ $t('we_miss_you') }}</div>-->
<!--      </el-radio>-->
<!--    </el-radio-group>-->
    <Subscription></Subscription>
    <afwSubscribe></afwSubscribe>
  </div>
</template>

<script>
import mbHeader from "../../components/mobile/mbHeader";
import afwSubscribe from "../../components/afw-subscribe/afw-subscribe";
import Subscription from '../Profile/emailSubscription';
import {mapActions, mapMutations, mapState} from "vuex";

export default {
  name: "mobileEmail",
  components: {mbHeader,Subscription,afwSubscribe},
  data() {
    return {
      subValue: null,
    };
  },
  methods: {
    ...mapActions('profile', ['fetchSubscribeEmail', 'postSubscribeEmail', 'putUnsubscribeEmail']),
    ...mapMutations('navbar', ['toggleLoginModalVisibility', 'toggleRegisterModalVisibility']),
    validEmail: function (email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    subChange() {
      if (this.subValue === true) {
        this.postSubscribeEmail(this.userDetails.email);
      } else {
        this.putUnsubscribeEmail(this.userDetails.email);
      }
    }
  },
  mounted() {
    this.fetchSubscribeEmail(this.userDetails.email)
      .then(res => {
        this.subValue = true;
      }).catch(err => {
      this.subValue = false;
    });
  },
  computed: mapState({
    userDetails: state => state.auth.userDetails,
  }),
}
</script>

<style scoped lang="less">
.subscriptionMb {
  min-height: 100vh;
  padding: 66px 16px 16px;
  background-color: rgba(0, 0, 0, 0.02);
  font-family: 'Source Sans Pro';
  font-size: 16px;

  /deep/ .afm-subscribe-container {
    width: 100%;
    padding-top: 60px;

    .sub-header {
      font-size: 12px;
      margin-bottom: 0px;
    }

    .sub-button-container {
      transform: scale(0.7);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/mobile/mobileEmail.vue